import type { ButtonVariant } from 'react-bootstrap/types'
import { ShowIf } from '@ztechapps/webui.util'
import { FormalizeButton } from '@ztechapps/webui.data-tools'
import { useChannelContext } from './Context'
import { RefreshChannelButton } from './RefreshChannelButton'

export type ComposerOtherButtonsProps = {
  /** Unset keeps the plain ChannelProvider mount's default look; ConversationProvider passes "link" for chromeless chrome. */
  variant?: ButtonVariant
}

// The Refresh + AI Formalize pair every composer's other-buttons slot shows — the one
// implementation both the plain `ChannelProvider` default and every `ConversationProvider`
// mount (inbox + record-page cards) share, so Formalize's `hideFormalizeButton` gate lives in
// exactly one place.
export const ComposerOtherButtons = ({ variant }: ComposerOtherButtonsProps) => {
  const { status, onRefresh, message, setMessage, onFormalize, hideFormalizeButton } = useChannelContext()

  return (
    <>
      <RefreshChannelButton status={status} onRefresh={onRefresh} variant={variant} />
      <ShowIf condition={!hideFormalizeButton}>
        <FormalizeButton
          message={message}
          isFormalizing={status.formalizing}
          onFormalize={onFormalize}
          onFormalized={setMessage}
          variant={variant}
          disabled={status.busy}
        />
      </ShowIf>
    </>
  )
}
